<template>
  <div class="style-browse-panel">
    <div class="sb-nav left" v-on:click="scrollLeft" :class="{viz: leftScrollvis}"></div>
    <div class="style-button-scroller" ref="wscroll">
      <div>
        <div class="style-button-holder" :style="scrollstyle" ref="scroller" :class="{anim: animation, sleft: doscroll}">

          <div class="select-word">{{ $nippets.select }}</div>
          <small-button v-for="gal in styles" :key="gal.gallery_id" :sel="gallery_id == gal.gallery_id"

            v-on:click="handleChoice(gal)">{{ gal.name.toLowerCase() }}</small-button>
          <div ref="lastone"></div>
        </div>
      </div>
    </div>
    <div class="sb-nav right" v-on:click="scrollRight" :class="{viz: rightScrollvis}"></div>
  </div>
</template>

<script>
import ViewablePanel from '@/mixins/ViewablePanel.js'
import stg from '@/data/home-style-galleries.js'

export default {
  props: {
    animation: Boolean,
    gallery: Object
  },
  mixins: [ViewablePanel],
  data () {
    return {
      styles: [],
      curpos: 0,
      scrollwidth:100,
      lastonex:0,
      scrolldist: 500,
      min:-100,
      gals: [],
      gallery_id: '0',
      doscroll: false,
      sleft: false
    }
  },
  computed: {
    rightScrollvis () {
      return this.doscroll && (this.curpos > this.min)
    },
    leftScrollvis () {
      return this.doscroll && (this.curpos < 0)
    },
    scrollstyle () {
      if(this.curpos === 0) return ''
      return 'transform: translate(' + this.curpos + 'px)'
    }
  },
  mounted () {
    this.updateSize()
    window.addEventListener('resize', this.updateSize)
    this.$k.waitfor(2000).then(() => {
      console.log('calling updatesize in mounted')
      this.updateSize()
    })
    
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.updateSize)
  },
  methods: {
    async updateSize () {
      
      this.scrollwidth = this.$refs.scroller.clientWidth
      console.log('scrollwidth', this.scrollwidth)
      
      let lx = this.$refs.lastone.getBoundingClientRect().x
      let swidth = lx
      console.log('totWidth', swidth)
      console.log('lx', lx)
      this.min =  0 -  (swidth - this.scrollwidth)
      this.scrolldist = Math.round(this.scrollwidth / 4)
      console.log('min is ' + this.min)
      if(!this.animation && window.innerWidth < 767){
        this.styles = this.gals.filter(el => el.top === true)
      }
      this.doscroll = swidth > this.scrollwidth
      this.sleft = this.doscroll
      
      
    },
    async init() {
      let galleries = await this.$store.dispatch('fetchGalleries')
      
      this.gals = galleries.filter(el => (el.animation === this.animation) && (!el.redir))
      this.gals.sort((el, el2) => { return el.name.localeCompare(el2.name) })
      if(!this.animation) {
        //this.styles = this.gals.filter(el => el.category === 'category')
        this.styles = this.gals.filter(el => stg.galleries.includes(el.url))
      }
      else {
        this.styles = this.gals.filter(el => stg.animGalleries.includes(el.url))
      }
      this.$nextTick(() => {
        this.updateSize()
      })
    },
    handleChoice (gal) {
      this.gallery_id = gal.gallery_id
      this.$emit('click', gal)
    },
    scrollRight() {
      if(this.curpos > this.min) {
        this.curpos -= this.scrolldist
      }
      if(this.curpos < this.min) this.curpos = this.min
      console.log('curpos', this.curpos)
    },
    scrollLeft() {
      if(this.curpos < 0) {
        this.curpos += this.scrolldist
      }
      if(this.curpos > 0) this.curpos = 0
    }
  },
  watch: {
    seen () {
      if(this.seen) {
        this.init()
      }
    },
    gallery () {
      if(this.gallery) {
        this.gallery_id = this.gallery.gallery_id
      }
      
    }
  }
  
}
</script>

<style>
  .style-browse-panel {
    display:flex;
    align-items:center;
    margin-left:-32px;
    margin-right:-32px;
  }

  .style-browse-panel .sb-nav{
    width:22px;
    height:20px;
    background-image:url('../../../assets/img/arrow-left.svg');
    background-size:contain;
    background-position: center center;
    background-size:65%;
    cursor:pointer;
    user-select: none;
    opacity:0;
  }

  .style-browse-panel .sb-nav.viz{
    opacity:1;
  }

  .style-browse-panel .sb-nav:hover{
    background-image:url('../../../assets/img/arrow-left-red.svg');
  }

  .style-browse-panel .sb-nav.right{
    background-image:url('../../../assets/img/arrow-right.svg');
  }


  .style-browse-panel .sb-nav.right:hover{
    background-image:url('../../../assets/img/arrow-right-red.svg');
  }


  .style-button-scroller{
    width: calc(100% - 64px);
    overflow:hidden;
  }

  .style-button-holder{
    display:flex;
    align-items:center;
    transition:all 0.4s ease;
    justify-content: center;
  }

  .style-button-holder.sleft
  {
    justify-content: flex-start;
  }



  a.smallbutton{
    display:inline-block;
    border-radius:5px;
    background-color:#a7aba1;
    color:#fff;
    font-size:14px;
    line-height:14px;
    padding:5px 8px;
    margin-right:3px;
    cursor:pointer;
    transition:all 0.15s ease;
    position:relative;
    user-select: none;
    white-space: nowrap;
  }

  a.smallbutton:hover{
    background-color:#ce0e2d;
    color:#fff;
  }

  .select-word{
    color:#7a7157;
    margin-right:12px;
    font-size:21px;
  }
  

  @media screen and (max-width:960px){
    .style-browse-panel .sb-nav{
      display:none;
    }
    .style-browse-panel{
      margin:0;
    }
    .style-button-scroller{
      width:100%;
      overflow:auto;
    }
    .style-button-holder{
      display:block;
      margin:0 10px;
    }

    .style-button-holder .nav-button{
      margin-bottom:5px;
    }
  }
</style>